<template>
  <BaseImportantNotification>
    A new version, {{ newAppVersion }} is available.
    <BaseButton
      kind="auxiliary"
      type="secondary"
      tint="red"
      text="Update"
      @click="restart()"
    />
  </BaseImportantNotification>
</template>

<script lang="ts" setup>
import controller from "@ctrl/controller";

import BaseButton from "@/components/base/BaseButton.vue";
import BaseImportantNotification from "@/components/base/BaseImportantNotification.vue";

const { applyUpdate } = controller;

defineProps<{
  newAppVersion: string | null;
}>();

const restart = () => {
  return applyUpdate();
};
</script>
